import styled from 'styled-components';

const Badge = styled.span`
  color: white;
`;

export default Badge;
